module.exports = __webpack_public_path__ + "img/img3.2ae73491.png";